export const environment = {
  production: false,
  hmr: true,
  baseUrl: 'https://api.staging.ikooworld.com',
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};
